<div class="ap-sign__pincode">
    {{ 'browser.pincode.instruction' | apContent }}
</div>
<ap-pincode-input [formControl]="pincodeControl()" [messages]="errors"> </ap-pincode-input>
@if (showLostCredentials()) {
    <ap-button [text]="true" class="ap-sign__pincode__button" data-bb="lostCredentials" (onClick)="lostCredentials.emit()">
        <ap-content key="browser.pincode.helptext"></ap-content>
    </ap-button>
}

<div class="ap-sign__pincode__buttons">
    @if (cancelText()) {
        <ap-button data-bb="cancel" variant="secondary" (onClick)="cancel.emit()">
            {{ cancelText() }}
        </ap-button>
    }
    <ap-submit [canSign]="canSign()" [submitText]="submitText()" (submitted)="submitted.emit()"> </ap-submit>
</div>
